<div class="container pt-5">

  <div class="container-fluid pt-3 text-secondary">
    <h2 class="fs-3 text-center">STANDARD CONDITIONS OF CARRIAGE</h2>
    <ol>
      <!-- 1 -->
      <li>
        Unless the context otherwise requires:
        <ol>
          <!-- 1.1 -->
          <li>
            “the Company” shall mean Skynet South Africa (Pty) Ltd t/a Skynet Worldwide Express and shall include any
            agent, sub-agent,
            independent contractor holding subsidiary affiliate or associate company of the Company.
          </li>
          <!-- 1.2 -->
          <li>
            “the Goods” shall include any envelope, container, package, pouch, box or covering in which the goods to be
            consigned are
            contained.
          </li>
          <!-- 1.3 -->
          <li>
            “the Sender” shall include the owner of the goods, the consignee and any person who has any interest in such
            goods or in their
            receipt (whether contingent or otherwise).
          </li>
          <!-- 1.4 -->
          <li>
            words which denote
          </li>
          <ol>
            <!-- 1.4.1 -->
            <li>
              any gender shall import and include the other genders,
            </li>
            <!-- 1.4.2 -->
            <li>
              a natural person shall import and include artificial person and vice-versa,
            </li>
            <!-- 1.4.3 -->
            <li>
              the singular shall import and include the plural and vice-versa.
            </li>
          </ol>
        </ol>
      </li>
      <!-- 1 -->

      <!-- 2 -->
      <li>
        The Company undertakes itself or through it’s agents or sub-contractors to convey the goods to the consignee.
        The Company
        contracts on the basis that it is not a common or public carrier and further on the basis that it is not to be
        treated as a bailee or
        depository.
        Under no circumstances shall any strict liability attach to the Company.
      </li>
      <!-- 2 -->

      <!-- 3 -->
      <li>
        &nbsp;
        <ol>
          <!-- 3.1 -->
          <li>
            All business (including the giving of advice or information to, or any other dealings with the Sender) is undertaken by the
            Company (whether a fee is charged or not), subject to these conditions as well as to the conditions appearing on the reverse
            side of the Company’s House-waybill notwithstanding any representations by any person representing or purporting to represent
            the Company and or anything in the Sender’s enquiry, acceptance or order to the contrary.
          </li>
          <!-- 3.2 -->
          <li>
            All good accepted by the Company are dealt with subject to the conditions stipulated by carriers, warehousemen,
            Government Departments and all other parties into whose possession or custody the goods may pass, or subject to whose
            authority they may at any time be.
          </li>
          <!-- 3.3 -->
          <li>
            This contract shall become binding on the Sender upon the signature on the face of the Company’s House-waybill by the
            delivery of the goods to the Company. Notwithstanding the foregoing or the acceptance of the goods by the Company, this
            contract shall not become binding on the Company unless the contract to forward the goods is accepted by the Company.
          </li>
        </ol>
      </li>
      <!-- 3 -->

      <!-- 4 -->
      <li>
        &nbsp;
        <ol>
          <!-- 4.1 -->
          <li>
            No amendment or consensual cancellation hereof or any provisions or terms hereof and no extension of time or waiver or
            relaxation or suspension of any of the provisions or terms hereof shall be binding unless recorded in a written document
            signed by a Director specifically authorised by the Board of Directors on behalf of the Company and the Sender. Any such
            extension, waiver or relaxation or suspension which is given or made shall be strictly construed as relating strictly to the
            matter in respect whereof it was made or given.
          </li>
          <!-- 4.2 -->
          <li>
            Nothing herein contained shall be construed as a waiver by the Company of any of its rights under any applicable law from time
            to time in force.
          </li>
        </ol>
      </li>
      <!-- 4 -->

      <!-- 5 -->
      <li>
        The Sender chooses it’s domicillium citandi et executandi for all purposes, whether in respect of court process, no􀆟ce or other
        documents or communications of whatsoever nature in terms hereof or otherwise the address appearing on the face of the
        Company’s waybill.
      </li>
      <!-- 5 -->

      <!-- 6 -->
      <li>
        The signatory on behalf of the sender, by his signature on the face of the Company’s waybill, warrants that he is authorised to
        contract with the Company on the basis of these condition on behalf of the Sender, the consignee, any owners(s) of the goods and
        any person having any interest whatsoever in the goods or in their receipt (whether contingent or otherwise).
      </li>
      <!-- 6 -->

      <!-- 7 -->
      <li>
        &nbsp;
        <ol>
          <!-- 7.1 -->
          <li>
            If any goods are tendered to the Company which could constitute a breach of any of the warranties (whether with or without
            its consent) the Company, in addition to its rights in common law, may deal with the goods (which may include the destruction
            thereof) as it deems fit, without liability to the Sender, without prejudice to its right to recover its charges and/or expenses,
            including those incurred in dealing as aforesaid, notwithstanding that it may have acted or failed to act negligently, the Sender
            warrants that
          </li>
          <ol>
            <!-- 7.1.1 -->
            <li>
              he has duly supplied on the efface of the Company’s House-waybill all particulars necessary to comply with applicable
              laws and rulings or requirements of the Company or any carrier including the nature of the goods.
            </li>
            <!-- 7.1.2 -->
            <li>
              all the particulars on the face of the Company’s waybill are true and correct in all respects for customs, insurance and
              (without limitation to the foregoing categories) any other purposes.
            </li>
            <!-- 7.1.3 -->
            <li>
              “unless specifically arranged with the duly authorized in writing by the Board of Directors of the Company, whether or
              not expressly otherwise stated on the face of the Company’s House-waybill, none of the goods are or may become
              dangerous, inflammable, radio-active, perishable, noxious or fall within any category of goods listed in the hazardous
              cargo manual issued from time to time by the International Air Transport Association, nor are any such goods by their
              nature likely or liable to harbour vermin or pests or cause injury or damage to any person, goods or property whatsoever
              nor will the goods (or any parts thereof) comprise livestock, Persian carpets, perishable and/or frozen food stuffs, household
              goods, or personal effects, explosives, arms and ammunition, precious metals and stones, bullion, specie, money
              and jewellery, an􀆟ques and works of art, motor vehicles, liquor, wine or cigarettes.
            </li>
            <!-- 7.1.4 -->
            <li>
              “the goods have been properly and sufficiently packed and/or prepared for carriage. The Company shall not be liable for
              any scratching, chipping, denting or marring of the goods or for mechanical, electrical or electronic derangement unless
              it is caused by visible violent external means”
            </li>
          </ol>
          <!-- 7.2 -->
          <li>
            The Sender shall be obliged to give any instructions to the Company timeously and in writing in order to afford the Company
            reasonable opportunity of complying with any such instructions, but the Company shall be entitled, but not obliged to act on
            oral instructions alone. If there is a conflict between oral and written instructions, the Company shall determine the course
            to be adopted in its sole discretion, having regard to the Sender(s) know requirements, if any. Notwithstanding that the
            Company may purport or attempt to act on any instructions, no liability shall attach to the Company for a failure (whether
            negligent or otherwise) to comply with or perform such instructions. The Company should be entitled to recover these
            charges and/or expenses including those incurred in ac􀆟ng in terms hereof.
          </li>
          <!-- 7.3 -->
          <li>
            The Company reserves the right to inspect the goods consigned at any 􀆟me and for this purpose shall be en􀆟tled to unwrap
            or open the goods.
          </li>
        </ol>
      </li>
      <!-- 7 -->

      <!-- 8 -->
      <li>
        &nbsp;
        <ol>
          <!-- 8.1 -->
          <li>
            The Sender hereby irrevocably and in rem saum authorises the Company to appoint such third parties as the Company may
            consider necessary for the purpose of procuring the forwarding of the goods to their destination on such conditions as may be
            stipulated by such third parties, but by which the Sender agreed to be bound (and, in this regard, if the premiums, rates or
            charges or the extent of liability of such third parties depends on the value declared, the nature of the declaration shall be
            determined, in the absence of wri􀆩en instructions by the Company in its sole discretion), and
          </li>
          <ol>
            <!-- 8.1.1 -->
            <li>
              In case of International Forwarding, to disburse such amounts on behalf of the Sender as may be agreed with such third
              party with the Company in its sole discretion. The Company shall be entitled in addition to its charges, to recover such
              amounts disbursed from time to time, from the Sender. The Company shall not be liable to the Sender in respect of any
              additional charges incurred on behalf of the Sender by reason of the means, route or procedure adopted by the Company
              (whether negligently or otherwise) or by reason of the fact that a saving might have been effected had some other
              means, route or procedure been adopted but shall be entitled to recover any such additional charges from the Sender.
            </li>
            <!-- 8.1.2 -->
            <li>
              In the case of Domestic Forwarding the Sender shall be liable only for the Company’s charges, it being agreed that the
              amount and rate of payment of disbursements by the Company to such third parties shall be of no concern to the Sender,
              who shall not be entitled to sign any of the documents relating thereto.
            </li>
            <!-- 8.1.3 -->
            <li>
              In all cases where there is a choice of tariff rates or premiums offered by carriers, warehouseman, underwriters or
              others, depending upon the value declared or the extent of the liability assumed by the carriers, warehousemen, underwriters
              or other person, it shall be in the entire discretion of the Company as to what declaration, if any, shall be made
              and what liability, if any, shall be imposed on the carrier, warehouseman, underwriter or other person unless express
              instructions in wri􀆟ng are timeously given by the Sender.
            </li>
            <!-- 8.1.4 -->
            <li>
              The Company shall be under no obligation to make any declaration to, or to seek any special protection or cover from
              the South African Transport Services in respect of any goods falling within the definition by that body
            </li>
            <ol>
              <!-- 8.1.4.1 -->
              <li>
                of dangerous or hazardous goods; or
              </li>
              <!-- 8.1.4.2 -->
              <li>
                of goods liable to be stored in the open.
              </li>
            </ol>
          </ol>
          <!-- 8.2 -->
          <li>
            <b>The Sender agrees that the Company shall have no responsibility or liability to the Sender:</b>
            <ol>
              <!-- 8.2.1 -->
              <li>
                for any act or omission on the part of any third party (whether negligent or not), nor shall the Company be obliged to take any ac􀆟on against any such third parties;
              </li>
              <!-- 8.2.2 -->
              <li>
                for any loss, destruction, damage or expense caused by delay in delivery or arising from the use of any weapon of war
                employing atomic or nuclear fission and/or other like reaction of radio force or matter or caused by political confiscation, seizure appropriation, expropriation, deprivation, requisition of title or destruction by or under the order of any
                government (whether civil, military or de facto) and/or other official(s);
              </li>
              <!-- 8.2.3 -->
              <li>
                for any loss or damage arising from or caused by earthquake, tremor, volcanic eruption, war invasion, act of foreign
                enemy, hostilities or war-like operations (whether war be declared or not), civil war, mu􀆟ny, rebellion, revolution,
                military or usurped power, or sacking or pillage in connection therewith.
              </li>
            </ol>
          </li>
          <!-- 8.3 -->
          <li>
            The Company shall have no obligation to take any action in respect of any goods which may be recognisable as belonging to
            the Sender, unless it has received suitable instructions relating to such goods together with all necessary documents and in
            particular the Company shall not be obliged to notify the Sender of the existence or whereabouts of the goods or to examine
            them or to take any steps for their identification, protection or preservation or for the preservation of any claim by the Sender
            or any other party against the carrier, insurer or any third party.
          </li>
          <!-- 8.4 -->
          <li>
            Subject to express instructions in writing given by the Sender, the Company reserves to itself complete freedom in respect or
            means, route and procedure to be followed in the handling and transportation of good-in particular the use of the term “courier”
            in the description of services does not, unless specifically otherwise stated, imply that goods will be accompanied by an
            individual at any or all stages of transit.
          </li>
        </ol>
      </li>
      <!-- 8 -->

      <!-- 9 -->
      <li>
        The Company shall not be obliged to effect insurance in respect of the goods consigned, notwithstanding that the Sender request
        the Company to insure the goods and tenders to pay the Company’s charge therefore and the Company agrees to the aforegoing.
        If the Company does not, for any reason, insure the goods, or if, having insured the goods, the relevant insurer does not for any
        reason pay any amount under the relevant insurance policy or pay an amount less than the amount claimed, then the Company
        shall be liable to the Sender in any manner other than for repayment of any charge made for such insurance, less any amount paid
        by the insurer.”
      </li>
      <!-- 9 -->

      <!-- 10 -->
      <li>
        If it is necessary for any examination to be held or action to be taken by the Company in respect of any discrepancy in the goods
        which are landed from any vessel, aircraft, vehicle or container, no responsibility shall attach to the Company for any failure
        (whether negligent or otherwise) to hold such examination or take any other action.
      </li>
      <!-- 10 -->
    </ol>
  </div>

</div>
